import * as _ from 'lodash'
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory, { IModel } from '../modelFactory';
import model from './model';

export interface IJobCostSetting extends IModel {
	workAreaKey?: string;
	group?: number;
	name?: string;
	value?: string;
	sortIndex?: number;
}

const jobCostSettingFactory = modelFactory.createFactory<IJobCostSetting>('JobCostSetting', _.assign({}, model, {

	workAreaKey: {
	},
	group: {
		rules: validator.enum('jobCostSettingGroups') // allow 0
	},
	name: {
		rules: validator.string()
	},
	value: {
		setFilters: valueFilters.toString,
		rules: [validator.string(), (val, target) => {
			if (target.name === 'taxRate') {
				const isNumber = validator.isNumber(val);
				if (!isNumber) {
					return 'Tax Rate is required.'
				}
			}
		}]
	},
	sortIndex: {
		setFilters: valueFilters.toNumber,
		rules: validator.number(true) // allow undefined
	}
}));

export default jobCostSettingFactory;